import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import grenadeGirl from "../../assets/Greenade-girl.png";
import hipBoy from "../../assets/hip-dude.png";
import ninja from "../../assets/ninja.png";
function Home(props) {
  let navigate = useNavigate();
  const [clicked, setClicked] = useState(false);
  return (
    <div className="w-full lg:h-[120vh] h-[90vh] relative overflow-hidden bg-[#B6C0E8]">
      <div className="absolute bottom-[-20px] bg-gradient-to-t from-[#B297D4] to-[#8d99c800] h-[20%] z-0  w-full"></div>
      <div className="flex">
        <img
          src={grenadeGirl}
          className="lg:w-5/12 md:w-5/12 w-7/12 absolute md:bottom-[-50px] bottom-[-10px] lg:left-[5%] 2xl:bottom-[-100px] left-[-10%]"
          alt=""
        />
        <img
          src={hipBoy}
          className="lg:w-5/12 md:w-7/12 w-9/12 absolute lg:left-[30%] left-[15%]  bottom-0 z-10"
          alt=""
        />
        <img
          src={ninja}
          className="lg:w-5/12 md:w-6/12 w-7/12 absolute lg:right-[5%] right-[-8%] 2xl:bottom-[-160px] md:bottom-[-100px] bottom-[-20px] z-0"
          alt=""
        />
      </div>
      <div className="flex  justify-center md:mt-[70vh] mt-[30vh] lg:mt-[100vh]">
        <a
          onClick={() => {
            setClicked(true);
          }}
          href="https://discord.com/invite/ZCBgakG7Sv"
          className={`${
            clicked ? `animate-bounce` : ``
          }btn bg-[#646AFB] z-10 font-medium relative  hover:bg-[#8285d8] tracking-tight letter-spacing:-0.05em mt-5 text-white text-[22px] rounded-md  py-3 px-10 transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-110 duration-300`}
        >
          Join our Discord
        </a>
      </div>
    </div>
  );
}

export default Home;
